module.exports = __webpack_public_path__ + "img/spain-skin-connective-and-musculoskeletal-diseases-female.63f2a496.png";